export default __webpack_public_path__ + "static/media/test.a467127d.png";